class DecimalAmount {

  number = 0;
  symbol = '';

  constructor(number, symbol = '') {
    this.number = typeof number === 'string' ? parseFloat(number) : number;
  }

  static make(number, symbol = '') {
    return new DecimalAmount(number);
  }

  floor(digits = 2) {
    this.number = Math.trunc(this.number * Math.pow(10, digits)) / Math.pow(10, digits);

    return this;
  }

  round(digits = 2) {
    const multiplier = Math.pow(10, digits);

    this.number = (Math.round(this.number * multiplier) / multiplier);

    return this;
  }

  toFixed(digits = 2) {
    return this.round(digits).get().toFixed(digits);
  }

  get() {
    return this.number;
  }

  toString(decimals = 2, dec = '.', sep = ',') {
    const n = !isFinite(+this.number) ? 0 : +this.number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);

    const toFixedFix = function (n, prec) {
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        const k = Math.pow(10, prec);

        return Math.round(n * k) / k;
    }

    let str = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');

    if (str[0].length > 3) {
        str[0] = str[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }

    if ((str[1] || '').length < prec) {
        str[1] = str[1] || '';
        str[1] += new Array(prec - str[1].length + 1).join('0');
    }

    return this.symbol + str.join(dec);
  }

}

export default DecimalAmount;